var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("settings.logs.title")))]),
      _c("v-data-table", {
        attrs: {
          items: _vm.logs,
          headers: _vm.headers,
          "footer-props": { "items-per-page-options": [5, 10, 25, 50, 100] },
          "server-items-length": _vm.totalCount,
          page: _vm.pagination.page,
          "sort-desc": _vm.pagination.descending,
          "items-per-page": _vm.pagination.rowsPerPage,
          "sort-by": _vm.pagination.sortBy,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "update:itemsPerPage": function($event) {
            return _vm.$set(_vm.pagination, "rowsPerPage", $event)
          },
          "update:items-per-page": function($event) {
            return _vm.$set(_vm.pagination, "rowsPerPage", $event)
          },
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.created_at))]),
                  _c("td", [_vm._v(_vm._s(props.item.userName))]),
                  _c("td", [_vm._v(_vm._s(props.item.ip))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.$i18n.locale === "pl"
                          ? props.item.activityNamePl
                          : props.item.activityNameEn
                      )
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(props.item.params))])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }